
import { Injectable } from "@nestjs/common";
import { WorkCalenderDto } from "./dto/work-calender.dto";
import { WorkCalender } from "./entity/work-calender.entity";



@Injectable()
export class WorkCalenderAdapter{

    public convertDtoToEntity(workcalenderDTO: WorkCalenderDto, isUpdate: boolean = false): WorkCalender{
        const workcalenderEntity = new WorkCalender();
        workcalenderEntity.id= workcalenderDTO.id;
        workcalenderEntity.employeeCode= workcalenderDTO.employeeCode;
        workcalenderEntity.date= workcalenderDTO.date;
        workcalenderEntity.shift= workcalenderDTO.shift;
        workcalenderEntity.shiftCode= workcalenderDTO.shiftCode;
        workcalenderEntity.workStationTeam= workcalenderDTO.workStationTeam;
        workcalenderEntity.inTime=workcalenderDTO.inTime;
        workcalenderEntity.outTime=workcalenderDTO.outTime;
        workcalenderEntity.attendanceStatus= workcalenderDTO.attendanceStatus;
        workcalenderEntity.leaveCode= workcalenderDTO.leaveCode;
        workcalenderEntity.holiday= workcalenderDTO.holiday;
        workcalenderEntity.department= workcalenderDTO.department;
        workcalenderEntity.contractor= workcalenderDTO.contractor;
        workcalenderEntity.isActive = workcalenderDTO.isActive === undefined ? true : workcalenderDTO.isActive;
        if(isUpdate){
            workcalenderEntity.updatedUser = workcalenderDTO.updatedUser;
        }else{
            workcalenderEntity.isActive = true;
            workcalenderEntity.createdUser = workcalenderDTO.createdUser;
        }
        return workcalenderEntity;
    }

    public convertEntityToDto(workcalenderObj: WorkCalender): WorkCalenderDto{
        const workcalenderDTO = new WorkCalenderDto;
        workcalenderDTO.id= workcalenderObj.id;
        workcalenderDTO.employeeCode= workcalenderObj.employeeCode;
        workcalenderDTO.date= workcalenderObj.date;
        workcalenderDTO.shift= workcalenderObj.shift;
        workcalenderDTO.shiftCode= workcalenderObj.shiftCode;
        workcalenderDTO.workStationTeam= workcalenderObj.workStationTeam;
        workcalenderDTO.inTime= workcalenderObj.inTime;
        workcalenderDTO.outTime= workcalenderObj.outTime;
        workcalenderDTO.attendanceStatus= workcalenderObj.attendanceStatus;
        workcalenderDTO.leaveCode= workcalenderObj.leaveCode;
        workcalenderDTO.holiday= workcalenderObj.holiday;
        workcalenderDTO.department= workcalenderObj.department;
        workcalenderDTO.contractor= workcalenderObj.contractor;
        workcalenderDTO.isActive = workcalenderObj.isActive;
        workcalenderDTO.createdAt = workcalenderObj.createdAt;
        workcalenderDTO.updatedAt = workcalenderObj.updatedAt;
        workcalenderDTO.updatedUser = workcalenderObj.updatedUser;
        workcalenderDTO.createdUser = workcalenderObj.createdUser;
        workcalenderDTO.versionFlag = workcalenderObj.versionFlag;
        return workcalenderDTO;

    }
}